import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {Booth} from 'vexpo-components';

export default class BoothPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      booth: {
        name: "Loading",
        contents: []
      }
    }
    this.dataURL = `expos/${props.expoID}/shows/${props.showID}/booths/${props.boothID}`;
    this.dataRef = firebase.database().ref(this.dataURL)
  }
  componentWillMount() {
    this.dataRef.on('value', (snapshot) => {
      var booth = snapshot.val().metadata;
      booth.id = snapshot.key
      booth.contents = [];
      for(var key in snapshot.val().contents) {
        var content = snapshot.val().contents[key];
        if(content.published) {
          content.id = key;
          booth.contents.push(content);
        }
      }
      booth.contents = booth.contents.sort((a,b) => a.order - b.order)
      this.setState({booth: booth});
    });
  }
  componentWillUnmount() {
    this.dataRef.off()
  }
  render() {
    return <Booth {...this.state.booth} preview={true} />
  }
}



// WEBPACK FOOTER //
// ./src/booth-preview/booth-preview.js